
export function numberInRange(input, min, max) {
  return input >= min && input <= max;
}

export function round10(value, exp) {
  return decimalAdjust('round', value, exp);
}

export function floor10(value, exp) {
  return decimalAdjust('floor', value, exp);
}

export function ceil10(value, exp) {
  return decimalAdjust('ceil', value, exp);
}

export function getRandomNumberInRange(min, max) {
  if (!(max || max === 0) || !(min || min === 0) || min >= max) {
    return NaN;
  }

  return Math.floor(Math.random() * (max - min + 1) + min);
}

/* eslint-disable */
function decimalAdjust(type, value, precision) {

  // If the precision is undefined or zero...
  if (typeof precision === 'undefined' || +precision === 0) {
    return Math[type](value);
  }

  value = +value;
  precision = +precision;

  // If the value is not a number or the precision is not an integer...
  if (isNaN(value) || !(typeof precision === 'number' && precision % 1 === 0)) {
    return NaN;
  }

  // Shift
  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - precision) : -precision)));

  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] + precision) : precision));
}
/* eslint-enable */
export function normalizeRotation(rotation) {
  return ((rotation % 360) + 360) % 360;
}
